import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { ChallengeDigitalWorkingHoursEntity } from '../../entities/challenge-insights/digital-working-hours/challenge-digital-working-hours.entity';
import { MetricValueType } from '../../../../interface/dtos';

export interface ChallengeDigitalWorkingHoursAggregateRootProps {
  before: ChallengeDigitalWorkingHoursEntity;
  after: ChallengeDigitalWorkingHoursEntity;
}

export class ChallengeDigitalWorkingHoursAggregateRoot extends Entity<ChallengeDigitalWorkingHoursAggregateRootProps> {
  protected _id: string;
  static create(
    props: ChallengeDigitalWorkingHoursAggregateRootProps,
    entityId?: string
  ): ChallengeDigitalWorkingHoursAggregateRoot {
    const id = entityId || v4();
    const entity = new ChallengeDigitalWorkingHoursAggregateRoot({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}

  get metricType() {
    return this.props.after.metricType;
  }
  get beforeValue() {
    return this.props.before.value;
  }
  get beforeCount() {
    return this.props.before.count;
  }
  get value() {
    return this.props.after.value;
  }
  get count() {
    return this.props.after.count;
  }
  get deviation() {
    return this.value - this.beforeValue;
  }
  get deviationPercentage() {
    return this.deviation !== 0 &&
      this.beforeValue !== 0 &&
      this.deviation &&
      this.beforeValue
      ? 100 * (this.deviation / this.beforeValue)
      : 0;
  }
  get beforeAverage() {
    return this.props.before.average;
  }
  get average() {
    return this.props.after.average;
  }
  get averageDeviation() {
    return this.average - this.beforeAverage;
  }
  get averageDeviationPercentage() {
    return this.beforeAverage !== 0
      ? ((this.average - this.beforeAverage) / this.beforeAverage) * 100
      : 0;
  }

  get afterUniqueUsersCount(): number {
    return this.props.after.uniqueUsers;
  }

  get beforeUniqueUsersCount(): number {
    return this.props.before.uniqueUsers;
  }

  get type(): MetricValueType {
    return this.props.after.type;
  }
}
